<template>
  <div class="health-analysis">
    <div class="card-container" v-if="healthAnalysis">
      <div class="card-header-center">
        <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/原理说明.png" alt="健康分析" class="header-icon" />
        <span class="header-title">健康分析</span>
      </div>

      <div class="analysis-item" v-if="healthAnalysis.healthAnalysisPrompt">
        <div class="item-title">健康分析提示</div>
        <div class="item-desc">{{ healthAnalysis.healthAnalysisPrompt }}</div>
      </div>

      <div class="analysis-item" v-if="healthAnalysis.commonManifestationsInHealthAnalysis">
        <div class="item-title">常见表现</div>
        <div class="item-desc">{{ healthAnalysis.commonManifestationsInHealthAnalysis }}</div>
      </div>

      <div class="divider-line"></div>

      <div class="section-title">
        <span class="dot"></span>潜在健康隐患提示
      </div>

      <div class="danger-waterfall" v-if="hiddenDangerList.length">
        <div
          class="danger-item"
          v-for="(item, index) in hiddenDangerList"
          :key="index"
        >
          <span class="danger-icon">!</span>
          <span class="danger-text">{{ item }}</span>
        </div>
      </div>
      <div class="empty-text" v-else>暂无潜在健康隐患提示</div>

      <div class="divider-line"></div>

      <div class="section-title">
        <span class="dot"></span>脏腑隐患
      </div>

      <div class="organ-tabs" v-if="organDangerList.length">
        <div
          class="organ-tab"
          :class="{ active: selectedOrganIndex === index }"
          v-for="(item, index) in organDangerList"
          :key="`${item.result}-${index}`"
          @click="selectOrgan(index)"
        >
          {{ item.result || "--" }}
        </div>
      </div>

      <div class="organ-panel" v-if="selectedOrganItem">
        <img
          v-if="selectedOrganItem.img"
          :src="selectedOrganItem.img"
          :alt="selectedOrganItem.result || '脏腑隐患'"
          class="organ-image"
        />
        <div class="organ-description" v-if="selectedOrganItem.description">
          {{ selectedOrganItem.description }}
        </div>
      </div>
      <div class="empty-text" v-else>暂无脏腑隐患数据</div>

      <div class="divider-line"></div>

      <div class="section-title">
        <span class="dot"></span>节气患病隐患
      </div>

      <div class="solar-term-section" v-if="solarTermHiddenDanger">
        <div class="solar-term-row">
          <span class="label-strong">当前节气：</span>
          <span class="label-value">{{ solarTermHiddenDanger.currentSolarTerm || "--" }}</span>
        </div>

        <div class="solar-term-row">
          <span class="label-strong">患病风险：</span>
          <span class="label-value">{{ solarTermHiddenDanger.illnessRisk || "--" }}</span>
        </div>

        <div
          class="solar-term-risk-text"
          v-if="solarTermHiddenDanger.riskPrompt"
        >
          <span class="label-strong">风险提示：</span>
          <span>{{ solarTermHiddenDanger.riskPrompt }}</span>
        </div>

        <div class="solar-term-chart">
          <img
            class="solar-term-dial"
            :src="solarTermDialUrl"
            alt="节气盘"
          />
          <img
            class="solar-term-pointer"
            :src="solarTermPointerUrl"
            alt="节气指针"
            :style="pointerStyle"
          />
        </div>
      </div>
      <div class="empty-text" v-else>暂无节气患病隐患数据</div>

      <div class="bottom-statement">
        重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论。如已有身体不适，请及时咨询医生。
        <div class="time-text" v-if="reportData.createAt">生成时间：{{ reportData.createAt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthAnalysis',
  props: {
    reportData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectedOrganIndex: 0,
      solarTermDialUrl: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/1_0002_新对话-(7).png',
      solarTermPointerUrl: 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/节气指针.png'
    };
  },
  computed: {
    healthAnalysis() {
      return this.reportData?.tongueReport?.healthAnalysis || null;
    },
    hiddenDangerList() {
      return this.healthAnalysis?.potentialHealthHiddenDangers || [];
    },
    organDangerList() {
      return this.healthAnalysis?.potentialZangFuOrganHiddenDangers?.list || [];
    },
    selectedOrganItem() {
      return this.organDangerList[this.selectedOrganIndex] || null;
    },
    solarTermHiddenDanger() {
      return this.healthAnalysis?.solarTermHiddenDanger || null;
    },
    pointerStyle() {
      const degrees = Number(this.solarTermHiddenDanger?.degrees || 0);
      return {
        transform: `translate(-50%, -50%) rotate(${degrees}deg)`
      };
    }
  },
  watch: {
    organDangerList: {
      immediate: true,
      handler(list) {
        this.selectedOrganIndex = list?.length ? 0 : -1;
      }
    }
  },
  methods: {
    selectOrgan(index) {
      this.selectedOrganIndex = index;
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.card-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.header-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
  object-fit: contain;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.analysis-item {
  margin-bottom: 20px;
}

.analysis-item:last-of-type {
  margin-bottom: 0;
}

.item-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.item-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #D0A77A;
  margin-right: 8px;
}

.divider-line {
  height: 1px;
  background: #e5e5e5;
  margin: 20px 0;
}

.danger-waterfall {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.danger-item {
  display: inline-flex;
  align-items: flex-start;
  max-width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  background: #f4efea;
  color: #7c6754;
  font-size: 14px;
  line-height: 1.5;
}

.danger-icon {
  width: 18px;
  height: 18px;
  min-width: 18px;
  border-radius: 50%;
  background: #b78552;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  margin-top: 1px;
}

.danger-text {
  word-break: break-word;
}

.organ-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.organ-tab {
  min-width: 68px;
  text-align: center;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 14px;
  color: #333;
  border: 1px solid #d9d9d9;
  background: #fff;
}

.organ-tab.active {
  color: #fff;
  background: #44c2c4;
  border-color: #44c2c4;
}

.organ-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.organ-image {
  width: 220px;
  max-width: 100%;
  object-fit: contain;
  margin-bottom: 14px;
}

.organ-description {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  text-align: center;
}

.solar-term-section {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

.solar-term-row {
  display: flex;
  flex-wrap: wrap;
}

.solar-term-risk-text {
  margin-top: 4px;
  text-align: justify;
}

.label-strong {
  color: #333;
  font-weight: bold;
}

.label-value {
  color: #333;
}

.solar-term-chart {
  position: relative;
  width: 260px;
  margin: 24px auto 0;
}

.solar-term-dial {
  display: block;
  width: 100%;
  height: auto;
}

.solar-term-pointer {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 60%;
  height: 60%;
  object-fit: contain;
  z-index: 2;
  transform-origin: center center;
}

.empty-text {
  font-size: 14px;
  color: #999;
  line-height: 1.6;
}

.bottom-statement {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  text-align: justify;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e5e5e5;
}

.time-text {
  margin-top: 4px;
}
</style>